import Model from "./base/model";

class OrderAdditionalServicesFiles extends Model{
  resourceName() {
    return "order_additional_services_files";
  }

  fields() {
    return {
      path: "",
      name: "",
      id: "",
      file: "",
    }
  }

  async files(id){
    return this.request(
      `order_additional_services/files/${id}` ,
      "GET",
      {}
    );
  }

  async deleteFile(id){
    return this.request(
      `order_additional_services/files/${id}` ,
      "DELETE",
      {}
    );
  }

}

export default new OrderAdditionalServicesFiles();
